import { render, staticRenderFns } from "./view-brand-manual.vue?vue&type=template&id=79ba1505&scoped=true&"
import script from "./view-brand-manual.vue?vue&type=script&lang=ts&"
export * from "./view-brand-manual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba1505",
  null
  
)

export default component.exports